var _circle, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFtd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.5,
    fill: "#101010",
    stroke: "url(#paint0_linear_5781_3392)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.06381 19V11.7273H10.7229V12.8317H7.38129V14.8061H10.4033V15.9105H7.38129V19H6.06381ZM11.4036 12.8317V11.7273H17.2061V12.8317H14.9583V19H13.6515V12.8317H11.4036ZM20.5892 19H18.1248V11.7273H20.639C21.361 11.7273 21.9813 11.8729 22.4998 12.1641C23.0206 12.4529 23.4207 12.8684 23.7 13.4105C23.9794 13.9527 24.1191 14.6013 24.1191 15.3565C24.1191 16.1141 23.9782 16.7652 23.6965 17.3097C23.4171 17.8542 23.0135 18.272 22.4855 18.5632C21.96 18.8544 21.3279 19 20.5892 19ZM19.4422 17.8601H20.5253C21.0319 17.8601 21.4545 17.7678 21.7931 17.5831C22.1316 17.3961 22.3861 17.1179 22.5566 16.7486C22.727 16.3769 22.8123 15.9129 22.8123 15.3565C22.8123 14.8002 22.727 14.3385 22.5566 13.9716C22.3861 13.6023 22.134 13.3265 21.8002 13.1442C21.4687 12.9595 21.0568 12.8672 20.5644 12.8672H19.4422V17.8601Z",
    fill: "#4EC040"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5781_3392",
    x1: 0,
    y1: 0,
    x2: 24,
    y2: 25.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101010"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFtd);
export default __webpack_public_path__ + "static/media/ftd.93d35844922a81999fd1e5845dfab2ae.svg";
export { ForwardRef as ReactComponent };